'use client';

import { Card, Heading } from '@backyard-ui/core';

import { Markdown } from '@/presenters/components/common/Markdown';
import { ShowMore } from '@/presenters/components/common/ShowMore';

interface TopContentProps {
  title: string;
  content?: string;
  children?: React.ReactNode;
}

function TopContent(props: Readonly<TopContentProps>) {
  const { title, content, children } = props;

  if (!content) {
    return (
      <Heading UNSAFE_className="ml-2" size="3xl">
        {title}
      </Heading>
    );
  }

  return (
    <Card.Root data-testid="top-content-card-container">
      <Card.Header>
        <Heading size="3xl">{title}</Heading>
      </Card.Header>
      <Card.Body>
        <ShowMore initialHeight={40} buttonAside>
          <Markdown content={content} />

          {children}
        </ShowMore>
      </Card.Body>
    </Card.Root>
  );
}

export default TopContent;
